import { useState, useEffect, useContext } from 'react';
import { FirebaseContext } from '../firebase';
import { UserContext } from '../context/userContext';

export function useMicroservices() {
  const [microservices, setMicroservices] = useState([]);
  const firebase = useContext(FirebaseContext);
  const { session } = useContext(UserContext);

  useEffect(() => {
    const currentOrg = session.user.organization_id;
    const entCollection = `enterprise-config/${session.user.enterprise_id}`;

    const orgMicroservices = firebase.db.collection(
      `${entCollection}/organizations/${currentOrg}/microservices/`
    );

    const unsubscribeMicroservices = orgMicroservices.onSnapshot((snapshot) => {
      let enabledMicroservices = [];
      snapshot.docs.forEach((doc) => {
        const microserviceId = Number(doc.id);
        const isEnabled = doc.data().enable;
        if (isEnabled) {
          enabledMicroservices.push(microserviceId);
        }
      });
      setMicroservices(enabledMicroservices);
    });

    return () => unsubscribeMicroservices();
  }, [firebase, session.user.enterprise_id, session.user.organization_id]);

  const isMicroserviceEnabled = (microserviceId) => {
    return microservices.includes(Number(microserviceId));
  };

  return { microservices, isMicroserviceEnabled };
}